import type { MapPoint } from '#ui/GoogleMap.js';

/** Location identity for de-duplication: rounded coordinates (~0.1 m), else the normalized address. */
function locationKey(point: MapPoint): string {
  if (point.latitude !== undefined && point.longitude !== undefined) {
    return `${point.latitude.toFixed(6)},${point.longitude.toFixed(6)}`;
  }
  return point.address?.toLowerCase().trim() ?? '';
}

/**
 * Keeps only the first map point at each location, so a hotel visited across several events (or a
 * place repeated over a multi-day activity) drops a single pin on the overview map.
 */
export function dedupeMapPoints<T extends MapPoint>(points: T[]): T[] {
  const seen = new Set<string>();
  return points.filter((point) => {
    const key = locationKey(point);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
